import type { ExperimentKey } from './types';
import type { GeometryKey } from './locales/keys';

export const HELP_LINES: Record<ExperimentKey, GeometryKey[]> = {
  'angle-chase': ['help.angle-chase.1', 'help.angle-chase.2', 'help.angle-chase.3'],
  'triangle-lab': ['help.triangle-lab.1', 'help.triangle-lab.2', 'help.triangle-lab.3'],
  pythagoras: ['help.pythagoras.1', 'help.pythagoras.2', 'help.pythagoras.3'],
  similarity: ['help.similarity.1', 'help.similarity.2', 'help.similarity.3'],
  'circle-theorems': ['help.circle-theorems.1', 'help.circle-theorems.2', 'help.circle-theorems.3'],
  'area-lab': ['help.area-lab.1', 'help.area-lab.2', 'help.area-lab.3'],
  transformations: ['help.transformations.1', 'help.transformations.2', 'help.transformations.3'],
  'coordinate-geometry': [
    'help.coordinate-geometry.1',
    'help.coordinate-geometry.2',
    'help.coordinate-geometry.3',
  ],
  constructions: ['help.constructions.1', 'help.constructions.2', 'help.constructions.3'],
};
